export default __webpack_public_path__ + "static/media/design1.56ae0821.jpg";